module.exports = __webpack_public_path__ + "img/img-13.cbe83d38.png";